var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A19A",
    fillRule: "evenodd",
    d: "m12.161 23.002 2.7-3.038c6.612-7.482 7.622-12.485 3.484-16.682-3.495-3.537-8.373-3.75-12-.343C1.91 7.096 2.838 13.56 8.665 19.46l3.495 3.537zm.026-8.036c2.428 0 4.393-2.303 4.393-5.144s-1.97-5.145-4.393-5.145S7.793 6.98 7.793 9.822s1.97 5.144 4.394 5.144",
    clipRule: "evenodd"
  })));
};
export default SvgStarFilled;